import React,{useEffect, useState} from 'react'
import json from './quiz.json'
import SportQuiz from './SportQuiz';
var data;
const Questions = (props) => {
 const data=json

 const sport=data[0].sport
 const maths=data[0].maths
 
 
  if(props.name === 'sport'){
    return (
     
      <div className="app1">    
        
      <SportQuiz name={sport}/>
      </div>);
  }
  else if(props.name === 'maths'){
    return (
      <div className="app2">   
      <SportQuiz name={maths}/>
      </div>);
  }
    
}
 
     
export default Questions